import module from 'contabilidad/clientescuentascontables/module.js'
import template from './template.html'
import {groupBy, orderBy} from 'lodash'

const sanitizarCliente = (item) => ({
  id: item.ID_Cliente,
  descripcion: item.Nombre,
})
const sanitizarCuentaBancaria = (item) => ({
  id: item.ID_Cuenta,
  descripcion: `${item.Banco} ${item.Cuenta} ${item.Moneda.substr(0, 3)}`,
  idCliente: item.ID_Cliente,
  moneda: item.Moneda,
})
const sanitizarConceptoContable = (item) => ({
  id: item.id,
  descripcion: item.concepto,
})

export class ContabilidadClientescuentascontablesDetalleInformacionComponent {
  data
  clientes
  cuentasBancarias
  conceptosContables
  catalogo = {
    clientes: [],
    cuentasBancarias: [],
    conceptos: [],
  }

  constructor (ContabilidadPlantillas) {
    this.ContabilidadPlantillasService = ContabilidadPlantillas
  }

  $onInit () {
    this.promise = this.ContabilidadPlantillasService.get()
      .then((response) => (this.plantillas = response.data))
      .then(() => {
        const clasificaciones = Object.keys(this.plantillas).map((id) => ({
          id, descripcion: this.plantillas[id].descripcion,
        }))

        this.catalogo.clasificaciones = clasificaciones
      })
  }

  $onChanges (changes) {
    if (changes.clientes) {
      this.clientes = this.clientes.map((item) => sanitizarCliente(item))
      this.clientes = orderBy(this.clientes, ['descripcion'])
      this.catalogo.clientes = this.clientes
    }

    if (changes.cuentasBancarias) {
      this.cuentasBancarias = this.cuentasBancarias.map((item) => sanitizarCuentaBancaria(item))
      this.cuentasBancarias = groupBy(orderBy(this.cuentasBancarias, ['idCliente', 'descripcion']), 'idCliente')
      this.catalogo.cuentasBancarias = this.cuentasBancarias
    }

    if (changes.conceptosContables) {
      this.conceptosContables = this.conceptosContables.map((item) => sanitizarConceptoContable(item))
      this.conceptosContables = orderBy(this.conceptosContables, ['descripcion'])
      this.catalogo.conceptosContables = this.conceptosContables
    }

    if (changes.data) {
      if (!this.data.cuentas.length)
        this.generarCuentas()
    }

    if (changes.data || changes.cuentasBancarias) {
      this.filtrarCuentasBancarias()
    }
  }

  editarClasificacion () {
    this.generarCuentas()
  }

  editarAdministrador () {
    this.filtrarCuentasBancarias()
  }

  filtrarCuentasBancarias () {
    this.catalogo.cuentasBancarias = (this.data && this.data.id_cliente_administrador)
      ? this.cuentasBancarias[this.data.id_cliente_administrador]
      : []
  }

  generarCuentas () {
    this.data.cuentas = []
    this.data.cuentas = (this.data && this.data.clasificacion)
      ? this.generarCuentasClasificacion(this.data.clasificacion, this.data.cuentas)
      : []
  }

  generarCuentasClasificacion (clasificaciones, cuentas) {
    if (!this.plantillas[clasificaciones]) return []

    return this.plantillas[clasificaciones].cuentas
      .map((predeterminado) => {
        let cuenta = cuentas.find((cuenta) => cuenta.indice === predeterminado.indice && cuenta.naturaleza === predeterminado.naturaleza)

        return {id: predeterminado.naturaleza + predeterminado.indice, ...predeterminado, ...cuenta}
      })
  }
}

module.component('contabilidadClientescuentascontablesDetalleInformacion', {
  controller: ContabilidadClientescuentascontablesDetalleInformacionComponent,
  template,
  bindings: {
    data: '<',
    clientes: '<',
    cuentasBancarias: '<',
    conceptosContables: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/components/detalle/informacion/component.js